"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _debounce = _interopRequireDefault(require("react-utils/debounce"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _UIExpandingTextArea = _interopRequireDefault(require("UIComponents/input/UIExpandingTextArea"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _TipAlert = _interopRequireDefault(require("./TipAlert"));

var _CloseableTipAlert = _interopRequireDefault(require("./CloseableTipAlert"));

var _EmbedLivePreview = _interopRequireDefault(require("./embed/EmbedLivePreview"));

var _requiredBy = _interopRequireDefault(require("../utils/requiredBy"));

var _embed = require("../utils/embed");

var _embed2 = require("../constants/embed");

var _embedSrc = require("../utils/embedSrc");

var _toolbar = require("../constants/toolbar");

var EmbedModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EmbedModal, _Component);

  function EmbedModal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EmbedModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EmbedModal).call(this, props));

    _this.handleSubmit = function () {
      var _this$props = _this.props,
          onSubmit = _this$props.onSubmit,
          onClose = _this$props.onClose,
          validateEmbed = _this$props.validateEmbed,
          useIframeEmbeds = _this$props.useIframeEmbeds;

      if (useIframeEmbeds) {
        var previewData = _this.state.previewData;
        onSubmit(previewData);
        onClose();
        return;
      }

      var embed = _this.state.embed.trim();

      var type = (0, _embedSrc.getEmbedType)(embed);
      var embedData = {};

      if (type === _embed2.EmbedFormats.URL) {
        embedData.url = embed;
      } else if (type === _embed2.EmbedFormats.EMBED) {
        embedData.embed = embed;
      }

      if (validateEmbed(embedData)) {
        onSubmit(embedData);

        _this.setState({
          error: _embed2.ErrorTypes.NONE
        });

        onClose();
      } else {
        _this.setState({
          error: _embed2.ErrorTypes.GENERAL
        });

        _this.embedInputRef.current.focus();
      }
    };

    _this.handleChange = function (_ref) {
      var value = _ref.target.value;
      var useIframeEmbeds = _this.props.useIframeEmbeds;
      var trimmedValue = (0, _embedSrc.sanitizeEmbedHtml)(value);
      var nextState = {};

      if (useIframeEmbeds) {
        var type = (0, _embedSrc.getEmbedType)(trimmedValue);

        if (type === _embed2.EmbedFormats.URL) {
          _this.debouncedFetchEmbedCode({
            url: trimmedValue
          });
        } else if (type === _embed2.EmbedFormats.EMBED) {
          _this.debouncedFetchEmbedCode({
            html: trimmedValue
          });
        } else {
          nextState = {
            previewLoadingStatus: _embed2.LoadingStatus.NONE,
            previewData: {},
            error: trimmedValue ? _embed2.ErrorTypes.GENERAL : _embed2.ErrorTypes.NONE
          };
        }
      } else {
        _this.debouncedUrlEmbedMatch(trimmedValue);
      }

      _this.setState(Object.assign({
        embed: value,
        error: _embed2.ErrorTypes.NONE,
        urlPasteMatch: false
      }, nextState));
    };

    _this.checkForMatchingEmbedUrl = function (value) {
      var match = (0, _embedSrc.matchesWhitelistedEmbedUrl)(value);

      if (match !== _this.state.urlPasteMatch) {
        _this.setState({
          urlPasteMatch: !!match
        });
      }
    };

    _this.fetchEmbedCode = function (data) {
      _this.setState({
        previewLoadingStatus: _embed2.LoadingStatus.LOADING
      });

      _this.props.fetchEmbedCode(data).then(function (result) {
        var previewData = _this.state.previewData;

        if (JSON.stringify(previewData) === JSON.stringify(result)) {
          _this.setState({
            previewLoadingStatus: _embed2.LoadingStatus.COMPLETE
          });
        } else {
          // Only update state if the data changed
          _this.setState({
            previewData: result,
            urlPasteMatch: result.source === 'url'
          });
        }
      }).catch(function (err) {
        setTimeout(function () {
          // Throw an async error for app-level sentries
          throw new Error(err);
        });

        _this.setState({
          previewLoadingStatus: _embed2.LoadingStatus.NONE,
          previewData: {},
          error: _embed2.ErrorTypes.FETCH,
          urlPasteMatch: false
        });
      });
    };

    _this.handleSetContentDone = function () {
      _this.setState({
        previewLoadingStatus: _embed2.LoadingStatus.COMPLETE
      });
    };

    _this.canInsert = function () {
      var useIframeEmbeds = _this.props.useIframeEmbeds;
      var _this$state = _this.state,
          embed = _this$state.embed,
          previewLoadingStatus = _this$state.previewLoadingStatus,
          error = _this$state.error;
      var canInsert = embed && embed.trim().length > 0;

      if (useIframeEmbeds) {
        // Allow submission if there is no error and the preview is loaded
        canInsert = canInsert && previewLoadingStatus === _embed2.LoadingStatus.COMPLETE && error === _embed2.ErrorTypes.NONE;
      }

      return canInsert;
    };

    _this.state = {
      embed: props.embed,
      error: _embed2.ErrorTypes.NONE,
      urlPasteMatch: false,
      previewLoadingStatus: _embed2.LoadingStatus.NONE,
      previewData: {}
    };
    _this.debouncedUrlEmbedMatch = (0, _debounce.default)(_this.checkForMatchingEmbedUrl, 300);
    _this.debouncedFetchEmbedCode = (0, _debounce.default)(_this.fetchEmbedCode, _toolbar.DEBOUNCE_TIMEOUT);
    _this.embedInputRef = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(EmbedModal, [{
    key: "renderUrlPasteMatch",
    value: function renderUrlPasteMatch() {
      if (!this.state.urlPasteMatch) {
        return null;
      }

      var _this$props2 = this.props,
          useIframeEmbeds = _this$props2.useIframeEmbeds,
          getUserAttributes = _this$props2.getUserAttributes,
          setUserAttribute = _this$props2.setUserAttribute;

      if (useIframeEmbeds) {
        return _react.default.createElement(_CloseableTipAlert.default, {
          title: _I18n.default.text((0, _embed.i18nKey)('urlPasteTipTitle')),
          getUserAttributes: getUserAttributes,
          setUserAttribute: setUserAttribute,
          attributeKey: "embedUrlPastingTip"
        }, _react.default.createElement(_FormattedMessage.default, {
          message: (0, _embed.i18nKey)('urlPastingTipText')
        }), _react.default.createElement(_UILink.default, {
          href: _embed2.EmbedReadMoreLink + "#providers",
          target: "_blank"
        }, _I18n.default.text((0, _embed.i18nKey)('urlPastingTipOembedLink'))), _react.default.createElement(_FormattedMessage.default, {
          message: (0, _embed.i18nKey)('urlPastingTipText2')
        }));
      }

      return _react.default.createElement(_TipAlert.default, {
        title: _I18n.default.text((0, _embed.i18nKey)('urlPasteTipTitle'))
      }, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _embed.i18nKey)('urlPastingTipText')
      }), _react.default.createElement(_UILink.default, {
        href: _embed2.EmbedReadMoreLink + "#providers",
        target: "_blank"
      }, _I18n.default.text((0, _embed.i18nKey)('urlPastingTipLink'))), _react.default.createElement(_FormattedMessage.default, {
        message: (0, _embed.i18nKey)('urlPastingTipText2')
      }));
    }
  }, {
    key: "renderPreview",
    value: function renderPreview() {
      if (!this.props.useIframeEmbeds) {
        return null;
      }

      var _this$state2 = this.state,
          previewLoadingStatus = _this$state2.previewLoadingStatus,
          previewData = _this$state2.previewData;
      return _react.default.createElement("div", null, previewLoadingStatus !== _embed2.LoadingStatus.NONE && _react.default.createElement(_UIFormLabel.default, {
        className: "m-top-2"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _embed.i18nKey)('previewLabel')
      })), previewLoadingStatus === _embed2.LoadingStatus.LOADING && _react.default.createElement(_UILoadingSpinner.default, {
        grow: true,
        size: "medium"
      }), _react.default.createElement(_EmbedLivePreview.default, {
        showPreview: previewLoadingStatus === _embed2.LoadingStatus.COMPLETE,
        data: previewData,
        onSetContentDone: this.handleSetContentDone
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          onClose = _this$props3.onClose,
          className = _this$props3.className,
          onCloseComplete = _this$props3.onCloseComplete;
      var _this$state3 = this.state,
          embed = _this$state3.embed,
          error = _this$state3.error;
      var validationMessage = '';

      if (error !== _embed2.ErrorTypes.NONE) {
        var validationKey = error === _embed2.ErrorTypes.FETCH ? 'errorFetch' : 'errorMessage';
        validationMessage = _I18n.default.text((0, _embed.i18nKey)(validationKey));
      }

      return _react.default.createElement(_UIModal.default, {
        width: 550,
        className: className,
        onCloseComplete: onCloseComplete
      }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: onClose
      }), _react.default.createElement(_H.default, null, _I18n.default.text((0, _embed.i18nKey)('modalTitle')))), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement(_FormattedMessage.default, {
        message: (0, _embed.i18nKey)('embedInsertInstructions')
      }), _react.default.createElement(_UIButton.default, {
        use: "link",
        external: true,
        href: _embed2.EmbedReadMoreLink
      }, "" + _I18n.default.text((0, _embed.i18nKey)('learnMore'))), _react.default.createElement(_UIFormControl.default, {
        htmlFor: "embed_txtarea",
        label: _I18n.default.text((0, _embed.i18nKey)('embedModalInputLabel')),
        error: error !== _embed2.ErrorTypes.NONE,
        validationMessage: validationMessage,
        className: "m-top-2"
      }, _react.default.createElement(_UIExpandingTextArea.default, {
        autoFocus: true,
        "data-gramm": false,
        defaultValue: embed,
        inputRef: this.embedInputRef,
        name: "embed_txtarea",
        maxHeight: 160,
        shrink: true,
        value: embed,
        onChange: this.handleChange
      })), this.renderUrlPasteMatch(), this.renderPreview()), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UIButton.default, {
        use: "primary",
        disabled: !this.canInsert(),
        onClick: this.handleSubmit
      }, _I18n.default.text((0, _embed.i18nKey)('insert'))), _react.default.createElement(_UIButton.default, {
        use: "secondary",
        onClick: onClose
      }, _I18n.default.text((0, _embed.i18nKey)('cancel')))));
    }
  }]);
  return EmbedModal;
}(_react.Component);

exports.default = EmbedModal;
EmbedModal.propTypes = {
  embed: _propTypes.default.string,
  onClose: _propTypes.default.func.isRequired,
  onSubmit: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  onCloseComplete: _propTypes.default.func,
  validateEmbed: _propTypes.default.func,
  useIframeEmbeds: _propTypes.default.bool,
  fetchEmbedCode: (0, _requiredBy.default)('useIframeEmbeds', _propTypes.default.func),
  getUserAttributes: (0, _requiredBy.default)('useIframeEmbeds', _propTypes.default.func),
  setUserAttribute: (0, _requiredBy.default)('useIframeEmbeds', _propTypes.default.func)
};
EmbedModal.defaultProps = {
  embed: '',
  validateEmbed: _embedSrc.defaultValidateEmbed
};
module.exports = exports.default;